import { AppRoute } from './enums'

export const pageTitles: Record<AppRoute, string> = {
  [AppRoute.Home]: 'Homepage',
  [AppRoute.TutorHome]: 'Homepage - Tutor',
  [AppRoute.Math]: 'Homepage - Math',
  [AppRoute.Ela]: 'Homepage - ELA',
  [AppRoute.Demo]: 'Homepage - Demo',
}
